import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import Clients from "@/components/Clients";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Leadership from "@/components/Leadership";
import News from "@/components/News";
import Trust from "@/components/Trust";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import InquiriesModal from "@/components/InquiriesModal";
import { setLenis } from "@/lib/scroll";

function App() {
  const [inquiriesOpen, setInquiriesOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen overflow-x-clip bg-[#F8FAFC] font-body text-slate-900 antialiased">
      <Navbar onViewInquiries={() => setInquiriesOpen(true)} />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Stats />
        <Clients />
        <Pricing />
        <Testimonials />
        <Leadership />
        <News />
        <Trust />
        <Contact />
      </main>
      <Footer />
      <InquiriesModal open={inquiriesOpen} onClose={() => setInquiriesOpen(false)} />
      <Toaster theme="light" position="bottom-right" richColors />
    </div>
  );
}

export default App;
